import {
  GET_ALL_ADVERSE_EVENTS,
  GET_ADVERSE_EVENT_BY_ID,
} from 'src/redux/types'

const INITIAL_STATE = {
  adverseEventList: [],
  pagination: {},
  selectedAdverseEvent: {},
}

const adverseEventReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_ADVERSE_EVENTS:
      return {
        ...state,
        adverseEventList: payload?.data || [],
        pagination: payload?.pagination || {},
        loader: false,
      }

    case GET_ADVERSE_EVENT_BY_ID:
      return {
        ...state,
        selectedAdverseEvent: payload?.data || {},
        loader: false,
      }

    default:
      return state
  }
}

export default adverseEventReducer
